import { render, staticRenderFns } from "./SurveyTest.vue?vue&type=template&id=3a7e9988&scoped=true"
import script from "./SurveyTest.vue?vue&type=script&lang=js"
export * from "./SurveyTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7e9988",
  null
  
)

export default component.exports